import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisalAdmin/actions/global';

import * as api from '../../api/maintenance/users';
import { makeApiActionCreatorV3 } from '../utils';

export const USERS_FETCH_START = 'USERS/USERS_FETCH_START';
export const USERS_FETCH_SUCCESS = 'USERS/USERS_FETCH_SUCCESS';
export const USERS_FETCH_ERROR = 'USERS/USERS_FETCH_ERROR';

export const USER_INACTIVATE_START = 'USERS/USER_INACTIVATE_START';
export const USER_INACTIVATE_SUCCESS = 'USERS/USER_INACTIVATE_SUCCESS';
export const USER_INACTIVATE_ERROR = 'USERS/USER_INACTIVATE_ERROR';

export const USER_ACTIVATE_START = 'USERS/USER_ACTIVATE_START';
export const USER_ACTIVATE_SUCCESS = 'USERS/USER_ACTIVATE_SUCCESS';
export const USER_ACTIVATE_ERROR = 'USERS/USER_ACTIVATE_ERROR';

export const USER_CREATE_START = 'USERS/USER_CREATE_START';
export const USER_CREATE_SUCCESS = 'USERS/USER_CREATE_SUCCESS';
export const USER_CREATE_ERROR = 'USERS/USER_CREATE_ERROR';

export const MASS_USERS_CREATE_START = 'USERS/MASS_USERS_CREATE_START';
export const MASS_USERS_CREATE_SUCCESS = 'USERS/MASS_USERS_CREATE_SUCCESS';
export const MASS_USERS_CREATE_ERROR = 'USERS/MASS_USERS_CREATE_ERROR';

export const USER_DELETE_START = 'USERS/USER_DELETE_START';
export const USER_DELETE_SUCCESS = 'USERS/USER_DELETE_SUCCESS';
export const USER_DELETE_ERROR = 'USERS/USER_DELETE_ERROR';

export const USER_UPDATE_START = 'USERS/USER_UPDATE_START';
export const USER_UPDATE_SUCCESS = 'USERS/USER_UPDATE_SUCCESS';
export const USER_UPDATE_ERROR = 'USERS/USER_UPDATE_ERROR';

export const USER_MODULES_FETCH_START = 'USERS/USER_MODULES_FETCH_START';
export const USER_MODULES_FETCH_SUCCESS = 'USERS/USER_MODULES_FETCH_SUCCESS';
export const USER_MODULES_FETCH_ERROR = 'USERS/USER_MODULES_FETCH_ERROR';

export const USER_MODULE_ASSIGN_START = 'USERS/USER_MODULE_ASSIGN_START';
export const USER_MODULE_ASSIGN_SUCCESS = 'USERS/USER_MODULE_ASSIGN_SUCCESS';
export const USER_MODULE_ASSIGN_ERROR = 'USERS/USER_MODULE_ASSIGN_ERROR';

export const USER_MODULE_DELETE_START = 'USERS/USER_MODULE_DELETE_START';
export const USER_MODULE_DELETE_SUCCESS = 'USERS/USER_MODULE_DELETE_SUCCESS';
export const USER_MODULE_DELETE_ERROR = 'USERS/USER_MODULE_DELETE_ERROR';

export const USER_ROLES_FETCH_START = 'USERS/USER_ROLES_FETCH_START';
export const USER_ROLES_FETCH_SUCCESS = 'USERS/USER_ROLES_FETCH_SUCCESS';
export const USER_ROLES_FETCH_ERROR = 'USERS/USER_ROLES_FETCH_ERROR';

export const USER_MODULE_ROLE_ADD_START = 'USERS/USER_MODULE_ROLE_ADD_START';
export const USER_MODULE_ROLE_ADD_SUCCESS =
  'USERS/USER_MODULE_ROLE_ADD_SUCCESS';
export const USER_MODULE_ROLE_ADD_ERROR = 'USERS/USER_MODULE_ROLE_ADD_ERROR';

export const USER_MODULE_ROLE_DELETE_START =
  'USERS/USER_MODULE_ROLE_DELETE_START';
export const USER_MODULE_ROLE_DELETE_SUCCESS =
  'USERS/USER_MODULE_ROLE_DELETE_SUCCESS';
export const USER_MODULE_ROLE_DELETE_ERROR =
  'USERS/USER_MODULE_ROLE_DELETE_ERROR';

export const USER_INIT_START = 'USERS/USER_INIT_START';
export const USER_INIT_SUCCESS = 'USERS/USER_INIT_SUCCESS';
export const USER_INIT_ERROR = 'USERS/USER_INIT_ERROR';

export const TAXING_UNITS_FETCH_START = 'USERS/TAXING_UNITS_FETCH_START';
export const TAXING_UNITS_FETCH_SUCCESS = 'USERS/TAXING_UNITS_FETCH_SUCCESS';
export const TAXING_UNITS_FETCH_ERROR = 'USERS/TAXING_UNITS_FETCH_ERROR';

export const USER_TAXING_UNITS_FETCH_START =
  'USERS/USER_TAXING_UNITS_FETCH_START';
export const USER_TAXING_UNITS_FETCH_SUCCESS =
  'USERS/USER_TAXING_UNITS_FETCH_SUCCESS';
export const USER_TAXING_UNITS_FETCH_ERROR =
  'USERS/USER_TAXING_UNITS_FETCH_ERROR';

export const USER_TAXING_UNITS_UPDATE_START =
  'USERS/USER_TAXING_UNITS_UPDATE_START';
export const USER_TAXING_UNITS_UPDATE_SUCCESS =
  'USERS/USER_TAXING_UNITS_UPDATE_SUCCESS';
export const USER_TAXING_UNITS_UPDATE_ERROR =
  'USERS/USER_TAXING_UNITS_UPDATE_ERROR';

export const USER_SEARCH_CRITERIA_FETCH_START =
  'USERS/USER_SEARCH_CRITERIA_FETCH_START';
export const USER_SEARCH_CRITERIA_FETCH_SUCCESS =
  'USERS/USER_SEARCH_CRITERIA_FETCH_SUCCESS';
export const USER_SEARCH_CRITERIA_FETCH_ERROR =
  'USERS/USER_SEARCH_CRITERIA_FETCH_ERROR';

export const USER_ALL_TAXING_UNITS_FETCH_START =
  'USERS/USER_ALL_TAXING_UNITS_FETCH_START';
export const USER_ALL_TAXING_UNITS_FETCH_SUCCESS =
  'USERS/USER_ALL_TAXING_UNITS_FETCH_SUCCESS';
export const USER_ALL_TAXING_UNITS_FETCH_ERROR =
  'USERS/USER_ALL_TAXING_UNITS_FETCH_ERROR';

export const SEARCH_USERS_BY_FILTERS_START =
  'USERS/SEARCH_USERS_BY_FILTERS_START';
export const SEARCH_USERS_BY_FILTERS_SUCCESS =
  'USERS/SEARCH_USERS_BY_FILTERS_SUCCESS';
export const SEARCH_USERS_BY_FILTERS_ERROR =
  'USERS/SEARCH_USERS_BY_FILTERS_ERROR';

export const GET_USER_SUMMARY_START = 'USERS/GET_USER_SUMMARY_START';
export const GET_USER_SUMMARY_SUCCESS = 'USERS/GET_USER_SUMMARY_SUCCESS';
export const GET_USER_SUMMARY_ERROR = 'USERS/GET_USER_SUMMARY_ERROR';

export const CLEAR_USER_SEARCH_LIST = 'USERS/CLEAR_USER_SEARCH_LIST';

export const CLEAR_USER_TOTAL = 'USERS/CLEAR_USER_TOTAL';

export const RESET_FILTERS = 'USERS/RESET_FILTERS';

export const UPDATE_FILTERS = 'USERS/UPDATE_FILTERS';

export const UPDATE_PAGE_FILTERS = 'USERS/UPDATE_PAGE_FILTERS';

export const USERS_READ_ONLY_SET_START = 'USERS/USERS_READ_ONLY_SET_START';
export const USERS_READ_ONLY_SET_SUCCESS = 'USERS/USERS_READ_ONLY_SET_SUCCESS';
export const USERS_READ_ONLY_SET_ERROR = 'USERS/USERS_READ_ONLY_SET_ERROR';

export const USERS_FORCE_LOG_OFF_SET_START =
  'USERS/USERS_FORCE_LOG_OFF_SET_START';
export const USERS_FORCE_LOG_OFF_SET_SUCCESS =
  'USERS/USERS_FORCE_LOG_OFF_SET_SUCCESS';
export const USERS_FORCE_LOG_OFF_SET_ERROR =
  'USERS/USERS_FORCE_LOG_OFF_SET_ERROR';

export const clearUserSearchList = () => ({
  type: CLEAR_USER_SEARCH_LIST,
});

export const clearUserTotal = () => ({
  type: CLEAR_USER_TOTAL,
});

export const resetFilters = () => ({
  type: RESET_FILTERS,
});

export const updateFilters = ({ name, value }) => ({
  type: UPDATE_FILTERS,
  payload: { name, value },
});

export const fetchUsers = makeApiActionCreatorV3(
  api.fetchUsers,
  USERS_FETCH_START,
  USERS_FETCH_SUCCESS,
  USERS_FETCH_ERROR,
);
export const setUsersReadOnly = makeApiActionCreatorV3(
  api.setUsersReadOnly,
  USERS_READ_ONLY_SET_START,
  USERS_READ_ONLY_SET_SUCCESS,
  USERS_READ_ONLY_SET_ERROR,
);
export const setUsersForceLogOff = makeApiActionCreatorV3(
  api.setUsersForceLogOff,
  USERS_FORCE_LOG_OFF_SET_START,
  USERS_FORCE_LOG_OFF_SET_SUCCESS,
  USERS_FORCE_LOG_OFF_SET_ERROR,
);
export const inActivateUser = makeApiActionCreatorV3(
  api.inActivateUser,
  USER_INACTIVATE_START,
  USER_INACTIVATE_SUCCESS,
  USER_INACTIVATE_ERROR,
);
export const activateUser = makeApiActionCreatorV3(
  api.activateUser,
  USER_ACTIVATE_START,
  USER_ACTIVATE_SUCCESS,
  USER_ACTIVATE_ERROR,
);
export const createUser = makeApiActionCreatorV3(
  api.createUser,
  USER_CREATE_START,
  USER_CREATE_SUCCESS,
  USER_CREATE_ERROR,
);
export const massCreateUsers = makeApiActionCreatorV3(
  api.massCreateUsers,
  MASS_USERS_CREATE_START,
  MASS_USERS_CREATE_SUCCESS,
  MASS_USERS_CREATE_ERROR,
);
export const deleteUser = makeApiActionCreatorV3(
  api.deleteUser,
  USER_DELETE_START,
  USER_DELETE_SUCCESS,
  USER_DELETE_ERROR,
);
export const updateUser = makeApiActionCreatorV3(
  api.updateUser,
  USER_UPDATE_START,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_ERROR,
);
export const fetchUserModules = makeApiActionCreatorV3(
  api.fetchUserModules,
  USER_MODULES_FETCH_START,
  USER_MODULES_FETCH_SUCCESS,
  USER_MODULES_FETCH_ERROR,
);
export const assignUserModule = makeApiActionCreatorV3(
  api.assignUserModule,
  USER_MODULE_ASSIGN_START,
  USER_MODULE_ASSIGN_SUCCESS,
  USER_MODULE_ASSIGN_ERROR,
);
export const deleteUserModule = makeApiActionCreatorV3(
  api.deleteUserModule,
  USER_MODULE_DELETE_START,
  USER_MODULE_DELETE_SUCCESS,
  USER_MODULE_DELETE_ERROR,
);
export const fetchUserRoles = makeApiActionCreatorV3(
  api.fetchUserRoles,
  USER_ROLES_FETCH_START,
  USER_ROLES_FETCH_SUCCESS,
  USER_ROLES_FETCH_ERROR,
);
export const addUserModuleRole = makeApiActionCreatorV3(
  api.addUserModuleRole,
  USER_MODULE_ROLE_ADD_START,
  USER_MODULE_ROLE_ADD_SUCCESS,
  USER_MODULE_ROLE_ADD_ERROR,
);
export const deleteUserModuleRole = makeApiActionCreatorV3(
  api.deleteUserModuleRole,
  USER_MODULE_ROLE_DELETE_START,
  USER_MODULE_ROLE_DELETE_SUCCESS,
  USER_MODULE_ROLE_DELETE_ERROR,
);
export const initUser = makeApiActionCreatorV3(
  api.initUser,
  USER_INIT_START,
  USER_INIT_SUCCESS,
  USER_INIT_ERROR,
);
export const fetchTaxingUnits = makeApiActionCreatorV3(
  api.fetchTaxingUnits,
  TAXING_UNITS_FETCH_START,
  TAXING_UNITS_FETCH_SUCCESS,
  TAXING_UNITS_FETCH_ERROR,
);
export const fetchUserTaxingUnits = makeApiActionCreatorV3(
  api.fetchUserTaxingUnits,
  USER_TAXING_UNITS_FETCH_START,
  USER_TAXING_UNITS_FETCH_SUCCESS,
  USER_TAXING_UNITS_FETCH_ERROR,
);
export const updateUserTaxingUnits = makeApiActionCreatorV3(
  api.updateUserTaxingUnits,
  USER_TAXING_UNITS_UPDATE_START,
  USER_TAXING_UNITS_UPDATE_SUCCESS,
  USER_TAXING_UNITS_UPDATE_ERROR,
);
export const fetchUserSearchCriteria = makeApiActionCreatorV3(
  api.fetchUserSearchCriteria,
  USER_SEARCH_CRITERIA_FETCH_START,
  USER_SEARCH_CRITERIA_FETCH_SUCCESS,
  USER_SEARCH_CRITERIA_FETCH_ERROR,
);
export const fetchAllTaxingUnits = makeApiActionCreatorV3(
  api.fetchAllTaxingUnits,
  USER_ALL_TAXING_UNITS_FETCH_START,
  USER_ALL_TAXING_UNITS_FETCH_SUCCESS,
  USER_ALL_TAXING_UNITS_FETCH_ERROR,
);
export const fetchUsersByFilters = makeApiActionCreatorV3(
  api.fetchUsersByFilters,
  SEARCH_USERS_BY_FILTERS_START,
  SEARCH_USERS_BY_FILTERS_SUCCESS,
  SEARCH_USERS_BY_FILTERS_ERROR,
);
export const getUserSummary = makeApiActionCreatorV3(
  api.getUserSummary,
  GET_USER_SUMMARY_START,
  GET_USER_SUMMARY_SUCCESS,
  GET_USER_SUMMARY_ERROR,
);

export const GET_USER_ATTRIBUTE_ASSOC = createRequestTypes(
  'USERS/GET_USER_ATTRIBUTE_ASSOC',
);

export const getUserAttributeAssoc = makeApiActionCreatorV3(
  api.getUserAttributeAssoc,
  GET_USER_ATTRIBUTE_ASSOC[START],
  GET_USER_ATTRIBUTE_ASSOC[SUCCESS],
  GET_USER_ATTRIBUTE_ASSOC[ERROR],
);

export const GET_SYSTEM_ATTRIBUTES = createRequestTypes(
  'USERS/GET_SYSTEM_ATTRIBUTES',
);

export const getSystemAttributes = makeApiActionCreatorV3(
  api.getSystemAttributes,
  GET_SYSTEM_ATTRIBUTES[START],
  GET_SYSTEM_ATTRIBUTES[SUCCESS],
  GET_SYSTEM_ATTRIBUTES[ERROR],
);

export const INSERT_USER_ATTRIBUTE_ASSOC = createRequestTypes(
  'USERS/INSERT_USER_ATTRIBUTE_ASSOC',
);

export const insertUserAttributeAssoc = makeApiActionCreatorV3(
  api.insertUserAttributeAssoc,
  INSERT_USER_ATTRIBUTE_ASSOC[START],
  INSERT_USER_ATTRIBUTE_ASSOC[SUCCESS],
  INSERT_USER_ATTRIBUTE_ASSOC[ERROR],
);

export const DELETE_USER_ATTRIBUTE_ASSOC = createRequestTypes(
  'USERS/DELETE_USER_ATTRIBUTE_ASSOC',
);

export const deleteUserAttributeAssoc = makeApiActionCreatorV3(
  api.deleteUserAttributeAssoc,
  DELETE_USER_ATTRIBUTE_ASSOC[START],
  DELETE_USER_ATTRIBUTE_ASSOC[SUCCESS],
  DELETE_USER_ATTRIBUTE_ASSOC[ERROR],
);

export const VALIDATE_PUBLIC_PORTAL_USER = createRequestTypes(
  'USERS/VALIDATE_PUBLIC_PORTAL_USER',
);

export const validatePublicPortalUser = makeApiActionCreatorV3(
  api.validatePublicPortalUser,
  VALIDATE_PUBLIC_PORTAL_USER[START],
  VALIDATE_PUBLIC_PORTAL_USER[SUCCESS],
  VALIDATE_PUBLIC_PORTAL_USER[ERROR],
);

export const SET_PUBLIC_AGENT = createRequestTypes('USERS/SET_PUBLIC_AGENT');

export const setPublicAgent = makeApiActionCreatorV3(
  api.setPublicAgent,
  SET_PUBLIC_AGENT[START],
  SET_PUBLIC_AGENT[SUCCESS],
  SET_PUBLIC_AGENT[ERROR],
);

export const CLEAR_PUBLIC_AGENT = createRequestTypes(
  'USERS/CLEAR_PUBLIC_AGENT',
);

export const clearPublicAgent = makeApiActionCreatorV3(
  api.clearPublicAgent,
  CLEAR_PUBLIC_AGENT[START],
  CLEAR_PUBLIC_AGENT[SUCCESS],
  CLEAR_PUBLIC_AGENT[ERROR],
);

export const updatePageFilters = ({ name, value }) => ({
  type: UPDATE_PAGE_FILTERS,
  payload: { name, value },
});
